const Footer = () => {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap justify-content-center">
          <div className="nk-footer-copyright">
            {" "}
            &copy; طراحی و توسعه توسط{" "}
            <a
              href="https://hamzehazizzadeh.ir/"
              target="_blank"
              className="text-primary fw-bold"
              without
              rel="noreferrer"
            >
              حمزه عزیززاده
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
